/**
 * Signing out on purpose, from the sidebar or Settings.
 *
 * This device stops getting the person's notifications first — someone
 * signing out may be on a shared computer, and until Oct 2026 the next person
 * there kept receiving their deal, payment and message alerts. That needs the
 * session, so it happens before the session ends. A failure is reported, and
 * sign-out still happens: leaving someone signed in is the worse outcome.
 *
 * Ending the session then clears the cached pages and the personal data left
 * on the device (providers/QueryProvider, utils/deviceData) — the same as an
 * idle timeout or an expired session, which deliberately leave notifications
 * on so an agent's own phone keeps alerting them.
 */

import { logout } from '../lib/pocketbase'
import { switchOffThisDevice } from '../api/pushNotifications'

export async function signOut(): Promise<void> {
  try {
    await switchOffThisDevice()
  } catch (err) {
    console.error('[sign-out] notifications could not be switched off on this device:', err)
  }
  logout()
}
